import { useCallback } from 'react'

import PlainIcon, { iconTypes, colorTypes } from 'app/common/ui-next/plain-icon'
import PlainDropdown, { PlainDropdownDefitem } from 'app/common/ui-next/plain-dropdown'
import { useDataBoxSelector } from 'app/common/data-box-store'
import { campSelector } from 'app/dataProviders/campSelector'
import { CampItem } from 'app/dataTypes/CampSelector'

import styles from './CampInfo.scss'


const emptyCamps = [] as Array<CampItem>
const empptyCampItem = { id: '', title: '...' } as CampItem

type Props = {
  studentId: string,
  active: boolean,
  currency: string,
}

const CampInfo = ({ studentId, active, currency }: Props) => {
  const allCamps = useDataBoxSelector<Array<CampItem> | null>(
    campSelector,
    () => campSelector.getAllCampsByStudentId(studentId)
  ) || emptyCamps

  const current = useDataBoxSelector<CampItem | null>(
    campSelector,
    () => campSelector.getCurrentByStudentId(studentId)
  ) || empptyCampItem

  const handleChengeCurrent = useCallback(({ id }) => {
    campSelector.setCurrent(studentId, id)
  }, [studentId])

  return (
    <div className={styles.root}>
      <PlainDropdown
        className={styles.dropdown}
        id={`camp_selector_${studentId}`}
        onChange={handleChengeCurrent}
        label="Выбор лагеря"
        placeholder={
          <PlainDropdownDefitem id={current.id} className={styles.placeholder}>
            <PlainIcon
              className={styles.icon}
              type={iconTypes.CAMP}
              width={12}
              height={12}
              color={active ? colorTypes.COLOR_PRIMARY : colorTypes.COLOR_GRAY}
            />
            <span>
              {`${current.balance} ${currency}`}
            </span>
          </PlainDropdownDefitem>
        }
        defaultSkin
        hideLabel
      >
        {allCamps.map(({ id, title, balance }) => (
          <PlainDropdownDefitem key={id} id={id} disabled={id === current.id}>
            {`${title} — ${balance} ${currency}`}
          </PlainDropdownDefitem>
        ))}
      </PlainDropdown>
    </div>
  )
}

export default CampInfo
